import { defineComponent as n, computed as u, createBlock as i, openBlock as r, unref as f, mergeProps as p } from "vue";
import b from "../SliderBase/SliderBase.vue2.js";
const k = /* @__PURE__ */ n({
  name: "RevRange",
  inheritAttrs: !1,
  __name: "Range",
  props: {
    disabled: { type: Boolean, default: !1 },
    keyboardStep: { default: 1 },
    label: {},
    max: {},
    min: { default: 0 },
    modelValue: {},
    showSteps: { type: Boolean, default: !1 },
    step: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: o }) {
    const s = e, d = o, t = u({
      get() {
        return s.modelValue;
      },
      set(a) {
        d("update:modelValue", a);
      }
    });
    return (a, l) => (r(), i(f(b), p(a.$attrs, {
      modelValue: t.value,
      "onUpdate:modelValue": l[0] || (l[0] = (m) => t.value = m),
      disabled: e.disabled,
      "keyboard-step": e.keyboardStep,
      label: e.label,
      max: e.max,
      min: e.min,
      "show-steps": e.showSteps,
      step: e.step
    }), null, 16, ["modelValue", "disabled", "keyboard-step", "label", "max", "min", "show-steps", "step"]));
  }
});
export {
  k as default
};
